<template>
  <div class="page-wrapper">
    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>

  </div>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  import TableList from 'components/TableList/index';
  import {getAssetsPutList} from "../../api/assets";
  import {formatDateTime} from "utils/format";
  export default {
    condition:'advice',
    components: {
      SearchGroup,
      TableList,
    },
    mounted() {
      this.findData()
    },
    computed: {
    },
    watch: {
    },
    data() {
      return {
        // searchParams:null,
        data: [],
        assetsFid:this.$route.query.id,
        columns: [
          {
            type: 'index',
            width: 60,
            key:'fid',
            align: 'center',
          },
          {
            title: ' '
          },
          {
            title: '资产编号 ',
            key: 'assetsCode',
            width: 180,
          },

          {
            title: ' '
          },
          {
            title: "资产类型",
            key: 'oneCategoryName',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: '资产名称',
            key: 'assetsName',
            width: 130,

          },
          {
            title: ' '
          },
          {
            title: "资产型号",
            key: 'sizeCode',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: "入库时间",
            key: 'putTime',
            width: 180,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['putTime'],false))
            }
          },
          {
            title: ' '
          },
            {
            title: "入库人",
            key: 'putPersonName',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: "入库数量",
            key: 'putNumber',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: "领用人",
            key: 'receivePersonName',
            width: 180,
          }
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10
      }
    },
    methods: {
      getData(){
        const params={
          assetsFid:this.assetsFid,
          page:this.page,
          limit:this.limit
        }
          getAssetsPutList(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          this.data=res.data.rows?res.data.rows:[]
        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        // this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
      }
    },
    created() {
    }
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
  .wrappertabs{
    min-height: 400px;
  }
</style>
<style>
  .feedback-text-wrapper{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .feedback-text-container > .ivu-table-cell > div{
    padding: 10px 0;
    overflow: hidden;
  }
</style>